// Belge Dizaynı alan kataloğu.
// Alan anahtarları (key) backend ResolveData çıktısındaki entity property adlarıyla (PascalCase)
// birebir eşleşir; böylece önizlemede sources[source][key] ile değer çözülür.
// Üç belge türü (Sipariş/İrsaliye/Fatura) için tasarım ekranı aynıdır; başlık kaynağı her zaman
// "Invoice" (Fatura) anahtarı altında sunulur — Sipariş/İrsaliye başlıkları da aynı alanları paylaşır.

// type: text | date | money | number  → önizlemede biçimleme için.
export const SOURCE_FIELDS = {
  Customer: {
    label: 'Müşteri',
    fields: [
      { key: 'TextId', label: 'Müşteri Kodu', type: 'text' },
      { key: 'Title', label: 'Ünvan', type: 'text' },
      { key: 'ShortName', label: 'Kısa Ad', type: 'text' },
      { key: 'Person', label: 'Yetkili', type: 'text' },
      { key: 'Adress', label: 'Adres', type: 'text' },
      { key: 'District', label: 'Mahalle/Semt', type: 'text' },
      { key: 'City', label: 'İl', type: 'text' },
      { key: 'Province', label: 'İlçe', type: 'text' },
      { key: 'PostCode', label: 'Posta Kodu', type: 'text' },
      { key: 'Phone', label: 'Telefon', type: 'text' },
      { key: 'CellPhone', label: 'Cep Telefonu', type: 'text' },
      { key: 'Email', label: 'E-Posta', type: 'text' },
      { key: 'TaxNumber', label: 'Vergi No', type: 'text' },
      { key: 'TaxOffice', label: 'Vergi Dairesi', type: 'text' },
      { key: 'IdentityNumber', label: 'TC Kimlik No', type: 'text' },
    ],
  },
  Invoice: {
    label: 'Belge (Fatura/İrsaliye/Sipariş)',
    fields: [
      { key: 'TextId', label: 'Belge No', type: 'text' },
      { key: 'PrintedNo', label: 'Basılı No', type: 'text' },
      { key: 'ReceiptNo', label: 'Makbuz No', type: 'text' },
      { key: 'Ettn', label: 'ETTN No', type: 'text' },
      { key: 'DocumentDate', label: 'Belge Tarihi', type: 'date' },
      { key: 'DueDate', label: 'Vade Tarihi', type: 'date' },
      { key: 'ShipDate', label: 'Sevk Tarihi', type: 'date' },
      { key: 'GrossAmount', label: 'Brüt Tutar', type: 'money' },
      { key: 'DiscountAmount', label: 'İskonto', type: 'money' },
      { key: 'VatBase', label: 'KDV Matrahı', type: 'money' },
      { key: 'VatAmount', label: 'KDV Tutarı', type: 'money' },
      { key: 'SpecialConsumptionTaxAmount', label: 'ÖTV', type: 'money' },
      { key: 'NetAmount', label: 'Genel Toplam', type: 'money' },
      { key: 'DeliveryAdress', label: 'Teslimat Adresi', type: 'text' },
      { key: 'Description1', label: 'Açıklama 1', type: 'text' },
      { key: 'Description2', label: 'Açıklama 2', type: 'text' },
    ],
  },
  InvoiceDetail: {
    label: 'Belge Kalemleri (Detay)',
    isDetail: true,
    fields: [
      { key: 'UnitOrder', label: 'Sıra', type: 'number' },
      { key: 'ProductTextId', label: 'Ürün Kodu', type: 'text' },
      { key: 'ProductName', label: 'Ürün Adı', type: 'text' },
      { key: 'Quantity', label: 'Miktar', type: 'number' },
      { key: 'UnitPrice', label: 'Birim Fiyat', type: 'money' },
      { key: 'DiscountAmount', label: 'İskonto', type: 'money' },
      { key: 'VatPercentage', label: 'KDV %', type: 'number' },
      { key: 'VatAmount', label: 'KDV Tutarı', type: 'money' },
      { key: 'GrossAmount', label: 'Brüt', type: 'money' },
      { key: 'NetAmount', label: 'Net', type: 'money' },
    ],
  },
  Vendor: {
    label: 'Distribütör',
    fields: [
      { key: 'TextId', label: 'Distribütör Kodu', type: 'text' },
      { key: 'Name', label: 'Distribütör Adı', type: 'text' },
      { key: 'City', label: 'Şehir', type: 'text' },
      { key: 'Region1', label: 'Bölge 1', type: 'text' },
      { key: 'Region2', label: 'Bölge 2', type: 'text' },
    ],
  },
  Warehouse: {
    label: 'Depo',
    fields: [
      { key: 'TextId', label: 'Depo Kodu', type: 'text' },
      { key: 'Name', label: 'Depo Adı', type: 'text' },
      { key: 'Adress', label: 'Depo Adresi', type: 'text' },
      { key: 'Type', label: 'Depo Tipi', type: 'text' },
    ],
  },
  ShipmentVehicle: {
    label: 'Araç',
    fields: [
      { key: 'Plaka', label: 'Plaka', type: 'text' },
      { key: 'Brand', label: 'Marka', type: 'text' },
      { key: 'Model', label: 'Model', type: 'text' },
      { key: 'Volume', label: 'Hacim', type: 'number' },
      { key: 'MaxWeight', label: 'Maks. Ağırlık', type: 'number' },
    ],
  },
  Payment: {
    label: 'Tahsilat',
    fields: [
      { key: 'TextId', label: 'Tahsilat No', type: 'text' },
      { key: 'ReceiptNo', label: 'Makbuz No', type: 'text' },
      { key: 'Amount', label: 'Tutar', type: 'money' },
      { key: 'PaymentDate', label: 'Tahsilat Tarihi', type: 'date' },
      { key: 'PaymentTypeName', label: 'Ödeme Türü', type: 'text' },
      { key: 'BankName', label: 'Banka', type: 'text' },
      { key: 'Description', label: 'Açıklama', type: 'text' },
    ],
  },
  Representative: {
    label: 'Dağıtıcı / Temsilci',
    fields: [
      { key: 'TextId', label: 'Temsilci Kodu', type: 'text' },
      { key: 'Name', label: 'Temsilci Adı', type: 'text' },
      { key: 'Plaka', label: 'Plaka', type: 'text' },
      { key: 'Reference', label: 'Referans', type: 'text' },
      { key: 'WorkingType', label: 'Çalışma Tipi', type: 'text' },
    ],
  },
};

export const DOC_TYPES = [
  { value: 0, label: 'Sipariş' },
  { value: 1, label: 'İrsaliye' },
  { value: 2, label: 'Fatura' },
  { value: 3, label: 'Tahsilat' },
];

export const TARGETS = [
  { value: 0, label: 'PC (Lazer / Nokta Vuruşlu)' },
  { value: 1, label: 'Termal (Mobil — Zebra Z320)' },
  { value: 2, label: 'Her İkisi' },
];

// mm cinsinden kağıt boyutları (genişlik x yükseklik, dikey).
export const PAPER_SIZES = {
  A4: { label: 'A4 (210×297mm)', widthMm: 210, heightMm: 297 },
  A5: { label: 'A5 (148×210mm)', widthMm: 148, heightMm: 210 },
  Letter: { label: 'Letter (216×279mm)', widthMm: 216, heightMm: 279 },
  // Zebra Z320 ~72mm yazdırılabilir genişlik; uzunluk içerikle büyür (rulo).
  Thermal72: { label: 'Termal 72mm (Zebra Z320)', widthMm: 72, heightMm: 200 },
  Thermal80: { label: 'Termal 80mm', widthMm: 80, heightMm: 200 },
  Custom: { label: 'Özel', widthMm: 210, heightMm: 297 },
};

export function paperDims(paperSize, orientation, customWidthMm, customHeightMm) {
  const base = PAPER_SIZES[paperSize] || PAPER_SIZES.A4;
  let w = paperSize === 'Custom' ? (Number(customWidthMm) || base.widthMm) : base.widthMm;
  let h = paperSize === 'Custom' ? (Number(customHeightMm) || base.heightMm) : base.heightMm;
  if (orientation === 1) { const t = w; w = h; h = t; } // yatay
  return { widthMm: w, heightMm: h };
}

// Belge türüne göre detay bandı kaynağı (frontend hep "InvoiceDetail" kataloğunu kullanır,
// backend doctype'a göre doğru detay tablosunu çözer).
export const DOC_TYPE_DETAIL_SOURCE = { 0: 'OrderDetail', 1: 'WaybillDetail', 2: 'InvoiceDetail', 3: null };

// Boş layout şablonu.
export function emptyLayout(paperSize = 'A4', orientation = 0) {
  const { widthMm, heightMm } = paperDims(paperSize, orientation);
  return {
    schemaVersion: 1,
    page: {
      paperSize, orientation,
      widthMm, heightMm,
      margins: { top: 10, right: 10, bottom: 10, left: 10 },
      unit: 'mm',
    },
    elements: [],
    detailBand: {
      enabled: false,
      source: 'InvoiceDetail',
      x: 0, y: 60, width: widthMm - 20,
      rowHeight: 7, showHeader: true, headerHeight: 7, showFooter: false,
      columns: [],
    },
    footer: { elements: [] },
  };
}
